import React from "react";
import s from "./style.module.scss";
import { userStatusTypes } from "shared/redux/models/User";

interface Props {
  type?: userStatusTypes;
  color?: `#${string}`;
  big?: boolean;
}

export const Status: React.FC<Props> = ({ type, color, big }) => {
  const classNames = `${s.status} ${big ? s.big : ""}`;

  return (
    <div style={{ background: color }} className={classNames}>
      {type ? type : "..."}
    </div>
  );
};
